/**
 * User Edit Schema
 *
 * Zod validation schema for user creation and update operations
 */

import z from "zod";

import { REGEX } from "@/lib/zod";

import { Role } from "../../../_shared";

/**
 * Schema for editing/creating users
 * Validates all user input fields including email, CPF, phone, and password
 */
export const saveUserArgsSchema = z.object({
  id: z.number().nullable(),
  shippingCompany: z.object({ id: z.number().or(z.string()).or(z.null()) }).nullable(),
  company: z.object({ id: z.number().or(z.string()).or(z.null()) }).nullable(),
  name: z.string(),
  email: z.email("Email inválido"),
  role: z.enum(Role, { message: "Cargo inválido" }),
  cpf: z.string().trim().regex(REGEX.CPF, "CPF inválido").or(z.literal("")).optional().nullable(),
  fone: z.string().trim().regex(REGEX.PHONE, "Telefone inválido").or(z.literal("")).optional().nullable(),
  password: z.string().min(6, "A senha deve ter no mínimo 6 caracteres"),
  receivesEmail: z.boolean(),
  isEnabled: z.boolean().optional(),
  isRoot: z.boolean().optional()
});
